import { Alert, AlertProps } from '@mui/material';

export function MuiAlert(props: AlertProps) {
  return <Alert {...props} />;
}
